// extracted by mini-css-extract-plugin
export default {"leagueText":"LeaguePage_leagueText__+-esJ","contextUsername":"LeaguePage_contextUsername__ve1pP","contextImageDiv":"LeaguePage_contextImageDiv__NYSXE"};